import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'lohi-app-regional-news',
  templateUrl: './regional-news.component.html',
  styleUrls: ['./regional-news.component.scss'],
})
export class RegionalNewsComponent implements OnInit {
  constructor() {}

  public ngOnInit(): void {}
}
